<template>
  <div class="filter-wrapper">
    <div class="filter-options">
      <v-row class="mb-3">
        <v-col cols="12" md="4">
          <DateIOSPicker label="Ngày" :date.sync="time" outlined :rules="[$rules.date, $rules.dateFromNow]" dense />
        </v-col>
      </v-row>
      <v-row class="mb-3">
        <v-col cols="12" md="4">
          <v-select
            v-model="present"
            :items="diligenceStatus"
            item-text="title"
            item-value="status"
            label="Trạng thái"
            dense
            outlined
            clearable
            hide-details
          />
        </v-col>
        <v-col cols="12" md="6" v-if="present === 'absent'">
          <RadioAbsentFilter @change="change" />
        </v-col>
        <v-col cols="12" md="4" v-if="present === 'present'">
          <RadioPresentFilter @change="change" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <GradeClassStudentSelect @changed="gradeClassStudentChange" @filter="onFilterChanged" />
        </v-col>
      </v-row>
    </div>
    <div class="filter-submit">
      <v-btn class="search-button" @click="onFilterChanged" outlined> Tìm kiếm </v-btn>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions, mapState } from 'vuex'
import { get } from 'lodash'
import DateIOSPicker from '@/components/basic/picker/DateIOSPicker.vue'
import GradeClassStudentSelect from '@/components/basic/filter/GradeClassStudentSelect.vue'
import RadioAbsentFilter from './RadioAbsentFilter.vue'
import RadioPresentFilter from './RadioPresentFilter.vue'

export default {
  components: { DateIOSPicker, GradeClassStudentSelect, RadioAbsentFilter, RadioPresentFilter },
  data() {
    return {
      selectedGrade: {},
      selectedClass: {},
      selectedStudent: {},
      status: '',
      present: null,
      time: moment().toISOString()
    }
  },
  computed: {
    ...mapState('constant', ['diligenceStatus'])
  },
  mounted() {
    this.onFilterChanged()
  },
  watch: {
    '$route.query': {
      handler(newValue) {
        if (newValue.date) {
          const decodedDate = decodeURIComponent(newValue.date)
          const parsedDate = moment(decodedDate, 'DD/MM/YYYY').toISOString()
          this.time = parsedDate
        }
      },
      immediate: true,
      deep: true
    }
  },

  methods: {
    ...mapActions('attendance', ['setDate']),
    gradeClassStudentChange(data) {
      this.selectedGrade = data.grade
      this.selectedClass = data.class
      this.selectedStudent = data.student
    },

    onFilterChanged() {
      const selectedDate = moment(this.time)
      const startOfDay = selectedDate.startOf('day').toISOString()
      const endOfDay = selectedDate.endOf('day').toISOString()

      this.setDate(startOfDay)

      const params = {
        date_gte: startOfDay,
        date_lte: endOfDay,
        grade: get(this.selectedGrade, 'id', ''),
        class: get(this.selectedClass, 'id', ''),
        student: get(this.selectedStudent, 'id', '')
      }
      if (this.present === 'present') {
        params.present = 'true'
        if (this.status !== 'all') {
          params.status = this.status
        }
      } else if (this.present === 'absent') {
        params.present = 'false'
        if (this.status !== 'all') {
          params.status = this.status
        }
      }

      this.$emit('onFilterChanged', params)
    },
    change(data) {
      this.status = data
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
  .filter-submit {
    margin-left: auto;
    align-self: flex-end;
  }
}
</style>
